import { FormattedMessage } from 'react-intl';

import { fantasy } from '@sorare/core/src/lib/glossary';
import { RewardType, SimpleReward } from '@sorare/core/src/lib/rewards';

type Props = {
  reward: SimpleReward;
};
export const LeagueRewardItemTitle = ({ reward }: Props) => {
  const { title, type } = reward;
  if (title) {
    return title;
  }

  if (type === RewardType.ARENA_TICKET) {
    return (
      <FormattedMessage
        id="LeagueRewardItemTitle.arenaTickets"
        defaultMessage="Arena Tickets"
      />
    );
  }
  if (type === RewardType.SHARD) {
    return <FormattedMessage {...fantasy.essence} />;
  }

  return type;
};
